import { ControlsService } from './controls.service';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListenerService } from './listener.service';
import { Configuracion } from '../interfaces';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {

  public config: Configuracion;
  public filteredInv: ReplaySubject<any[]> = new ReplaySubject<any[]>();
  public inventarios: any[] = [];
  constructor(private listener: ListenerService) {
   
    // realTime.callback.subscribe((data) => {
    //   if (data.status === 'success') {
    //     this.inventarios = data.data;
    //     this.filteredInv.next(data.data.slice());
    //   }
    // });

    this.cargar();

  }

  async cargar() {
    if (!localStorage.getItem('configPD')) {
      await new Promise(d => this.listener.addListener('config@end', d));
    }
    this.config =  JSON.parse(localStorage.getItem('configPD')) as Configuracion;
  }

}

